<template>
  <v-layout row justify-center>

    <v-dialog v-model="visible" max-width="325px" v-click-outside="close">
      <v-card>

        <v-card-title class="title font-weight-regular justify-space-between">
          <span>{{ currentTitle }}</span>
        </v-card-title>
        <v-form @submit.prevent="next">
          <v-window v-model="step" >
            <v-window-item :value="1">
              <v-card-text>
                <v-text-field
                  name="contactId"
                  :label="$t('acc_username_hint')"
                  v-if="visible"
                  autofocus
                  v-model="contactId"
                  :error-messages="!validation.name ? [$t('acc_username_empty')] : !validation.nameReg ? [$t('acc_username_alphanumeric')] : []"
                />
                <span class="caption error--text text--darken-1" v-if="result > 0">
                  {{$t('contacts_verification_fail')}}
                </span>

              </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
              <div class="pa-3 text-xs-center" :v-if="step === 2">
                <user-avatar 
                  :avatar="getUserAvatar"
                  :username="username" 
                  :size="192"
                />

                <v-text-field
                  v-model="username"
                  :label="$t('contacts_name')"
                  :error-messages="!validation.username ? [$t('acc_username_empty')] : []"
                />
                <v-text-field
                  :value="fingerprint"
                  :label="$t('contacts_fingerprint')"
                  readonly
                />
              </div>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              flat
              @click="back"
            >
              {{ backTitle }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loading"
              :disabled="nextDisabled"
              color="primary"
              depressed
              type="submit" 
            >
              {{ nextTitle }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<style>
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>

<script> 
  import UserAvatar from '@common/UserAvatar.vue'
  import validationUtils from '@utils/validationUtils'

  export default {
    data: () => ({
      contactId: '',
      username: '',
      avatar: '',
      fingerprint: '',
      loader: null,
      loading: false,
      step: 1,
      result: 0,
    }),
    components: { UserAvatar },
    computed: {
      currentTitle () {
        switch (this.step) {
          case 1: return this.$t('contacts_add')
          case 2: return this.contactId
          default: return ''
        }
      },
      nextTitle() {
        return (this.step === 1) ? this.$t('next_btn') : this.$t('chat_menu_add_users_drawer')
      },
      backTitle() {
        return (this.step === 1) ? this.$t('cancel') : 'Back'
      },
      getUserAvatar() {
        return (this.step === 2) ? this.avatar : ''
      },
      nextDisabled() { 
        if (this.step == 1)
          return this.contactId.length == 0
        return (this.step == 2 && this.username === '')
      },
      validation: function () {
        return {
          name: !!this.contactId.trim(),
          nameReg: validationUtils.validateId(this.contactId),
          username: !!this.username.trim()
        }
      },
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      }
    },
    methods: {
      close() {
        if (!this.visible)
          return
        // reset all variables
        this.step = 1
        this.result = 0
        this.contactId = ''
        this.username = ''
        this.avatar = ''
        this.fingerprint = ''
        // notify parent
        this.$emit('update:visible', false)
      },
      next() {
        if (this.step < 2) {
          this.loader = 'loading'
          const l = this.loader
          this.$store.dispatch('verifyContact', this.contactId).then((args) => {
            this[l] = false
            this.verified(args)
          })
          return
        }

        this.$store.dispatch('addContact', { 
          contactId: this.contactId, 
          username: this.username, 
          avatar: this.avatar 
        })
        this.close()
      },
      back() {
        if (this.step == 1) {
          this.close()
          return
        }
        this.step--
      },
      verified(args) {
        this.result = args.result
        if (args.result == 0) {
          this.step++
          this.username = (args.name == '') ? this.contactId : args.name
          this.avatar = args.avatar
          this.fingerprint = args.fingerprint.substr(0, 32)
        }
      },
      setContactId(contactId) {
        // reset all variables
        this.step = 1
        this.result = 0
        this.contactId = ''
        this.username = ''
        this.avatar = ''
        this.fingerprint = ''

        this.contactId = contactId
        this.next()
      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]
        setTimeout(() => {
          this[l] = false
          // TODO: show error
        }, 5000)
        this.loader = null
      }
    }
  }
</script>